/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/8/2019.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl';
import {ROLES} from "../security/SecurityConst";
import WorkerDashboard from './WorkerDashboard'
import FleetManagerDashboard from './FleetManagerDashboard'
import AdminDashboard from './AdminDashboard'
import BreadCrumb from "../common/Bradcrumb";
import SuperAdminDashboard from "./UIconfigAdminDashBoard"


class Dashboard extends React.Component {

    render() {
        let dashboardComponent;

        const userRole = this.props.userProfile.roles[0].name;
        switch (userRole) {
            case ROLES.WORKER:
            case ROLES.ADVANCED_WORKER:
            case ROLES.HDA_MECHANIC:
            case ROLES.AIRTIME_GENERIC:
                dashboardComponent = <WorkerDashboard />
                break;
            case ROLES.FLEET_MANAGER:
            case ROLES.OBSERVER:
                dashboardComponent = <FleetManagerDashboard />
                break;
            case ROLES.ADMIN:
            case ROLES.HDA_ADMIN:
                dashboardComponent = <AdminDashboard />
                break;
            case ROLES.UI_CONFIG_ADMIN:
                dashboardComponent = <SuperAdminDashboard/>
                break;
            default:
                dashboardComponent = null
                break;
        }

        return (
            <div id="dashboard" >
                {dashboardComponent}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

export default injectIntl(withRouter(connect(mapStateToProps)(Dashboard)))